<template>
  <v-row
    align="stretch"
    justify="start"
  >
    <v-col
      cols="12"
    >
      <customer-price-groups @update="update" />
      <base-material-card
        color="coolrunner"
        icon="mdi-tag-multiple"
        inline
        class="px-5 py-3"
        lg="4"
      >
        <template v-slot:after-heading>
          <div class="text-h2 font-weight-light">
            {{ $t('customer_specific') + ' ' + $t('prices') }}
          </div>
        </template>

        <price-table
          context="customers"
          @update="update"
        />
      </base-material-card>
      <price-sheet
        :last-updated="lastUpdate"
        context="customers"
      />
    </v-col>
  </v-row>
</template>
<script>

  import Auth from '../../../../mixins/Auth'
  export default {
    mixins: [Auth],
    data () {
      return {
        lastUpdate: Date.now(),
      }
    },
    methods: {
      update: function () {
        this.lastUpdate = Date.now()
      },
    },
  }
</script>
